// src/components/ChatbotButton.js
import React, { useState } from "react";
import ChatbotModal from "../ChatbotModal/ChatbotModal";
import { HiOutlineChatBubbleBottomCenterText } from "react-icons/hi2";
import "./ChatbotButton.css";

const ChatbotButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button className="chatbot-button" onClick={() => setIsOpen(true)}>
        {/* 💬 */}
        <div className="bot-div">
          <HiOutlineChatBubbleBottomCenterText />
        </div>
        {/* ֎ */}
      </button>
      {isOpen && <ChatbotModal onClose={() => setIsOpen(false)} />}
    </>
  );
};

export default ChatbotButton;
